import { Link } from "react-router";
import { getFormattedCaaSImageUrl } from "@components/OptimisedImage/utils/helpers";
import { IndividualTrendingCardProps } from "@features/pulse/components/trendingCards/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { CaaSImageFilters } from "@typings/OptimisedImage";
import { cn, getUrlQuery } from "@util/helpers";

const IndividualTrendingCard = ({
  title,
  urlPath,
  className,
  media,
  onClick,
  linkParams,
}: IndividualTrendingCardProps) => {
  const { src, alt = title, width = 316, height = 211 } = media || {};

  const defaultFilters: CaaSImageFilters = {
    w: ImagePresets.SMALL,
    dpr: 1,
    f: "webp",
  };
  const imgSrc = getFormattedCaaSImageUrl(src, defaultFilters);

  const linkParamsObj = linkParams
    ? new URLSearchParams({ ref: linkParams })
    : undefined;
  const _link = urlPath + getUrlQuery(urlPath, linkParamsObj);

  return (
    <Link
      to={_link}
      reloadDocument
      className={cn("group relative min-h-[250px]", className)}
      data-testid="individual-trending-card-component"
      onClick={onClick}
    >
      {imgSrc ? (
        <img
          src={imgSrc}
          alt={alt}
          width={width}
          height={height}
          className="aspect-3x2 h-[250px] w-full rounded-t-4px object-cover pb-10"
        />
      ) : null}

      <div
        className={cn(
          "absolute bottom-0 flex h-full items-end rounded-b-4px p-3",
          "bg-[linear-gradient(180deg,rgba(29,32,50,0)_43.13%,#1D2032_65.78%)]"
        )}
      >
        <p className="line-clamp-5 font-lct text-base font-bold leading-[130%] -tracking-2% text-white group-hover:underline">
          {title}
        </p>
      </div>
    </Link>
  );
};

export default IndividualTrendingCard;
